import {
  DELETE_PLC_SAFETY_EVENT,
  DELETE_PLC_SAFETY_EVENT_SUCCESSFUL,
  DELETE_PLC_SAFETY_EVENT_FAILED,
} from './actionTypes';

const initialState = {
  deletePlcSafetyEventError: null,
  messagePlcSafetyEvent: null,
  loadingDeletePlcSafetyEvent: false,
};

const deleteEvent = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_PLC_SAFETY_EVENT:
      state = { ...state, loadingDeletePlcSafetyEvent: true, deletePlcSafetyEventError: null };
      break;
    case DELETE_PLC_SAFETY_EVENT_SUCCESSFUL:
      state = {
        ...state,
        loadingDeletePlcSafetyEvent: false,
        messagePlcSafetyEvent: action.payload,
        deletePlcSafetyEventError: null,
      };
      break;
    case DELETE_PLC_SAFETY_EVENT_FAILED:
      state = {
        ...state,
        messagePlcSafetyEvent: null,
        loadingDeletePlcSafetyEvent: false,
        deletePlcSafetyEventError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default deleteEvent;
